<template>
  <div class="vonage-loader-backdrop">
    <div class="vonage-loader-container">
      <img 
        src="/assets/vonage-loader.gif" 
        alt="Loading" 
        class="vonage-loader-gif"
      />
      <p v-if="message" class="vonage-loader-message">
        {{ message }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VonageLoader',
  props: {
    message: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.vonage-loader-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  /* The <top-layer> host that carries this loader is pointer-events: none, so
     the backdrop has to opt back in to keep blocking interaction while loading. */
  pointer-events: auto;
}

.vonage-loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  padding: 32px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.vonage-loader-gif {
  width: 120px;
  height: 120px;
  object-fit: contain;
}

.vonage-loader-message {
  margin-top: 16px;
  color: #333333;
  font-size: 16px;
  text-align: center;
  font-weight: 500;
}
</style>